import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=d075c6c2&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/background/order.css?vue&type=style&index=0&id=d075c6c2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d075c6c2",
  null
  
)

export default component.exports